import React from "react";
import ButtonOrange from "@shared/uiNew/Button/button_orange";
import * as styles from "./FinalCTA.module.scss";

import { finalCtaData, REGISTER_URL } from "@shared/arrays/sales";

export function FinalCTA() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.title}>{finalCtaData.title}</h2>

        <p className={styles.lines}>
          {finalCtaData.lines.map((line) => (
            <span key={line}>{line}</span>
          ))}
        </p>

        <ButtonOrange
          icon="arrow"
          text={finalCtaData.cta}
          href={REGISTER_URL}
          type="link"
        />
      </div>
    </section>
  );
}

export default FinalCTA;
